import statement from "./modules/statement";
import statementType from "./modules/statementType";

export default {
    namespaced: true,
    modules: {
        statement,
        statementType
    }
};
